import useFetch from "../../../hooks/useFetch";
import {useNotification} from "../../../store/admin/NotificationProvider";
import {useEffect, useRef, useState} from "react";
import {
    Button,
    Checkbox,
    FormControlLabel, Grid, styled,
    TextField
} from "@mui/material";
import CONFIG from "../../../config/_config";
import ChipsSelector from "../../_atoms/admin/ChipsSelector";
import DialogModal from "../../_atoms/admin/DialogModal";
import FileUploadIcon from '@mui/icons-material/FileUpload';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});


function getBase64(file) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            resolve({ state: 'ok', base64: reader.result })
        };
        reader.onerror = function (error) {
            resolve({ state: 'error', error });
        };
    })

}

const base64ToObjectURL = async (base64) => {
    const blob = await base64ToBlob(base64);
    return URL.createObjectURL(blob);
}

const base64ToBlob = async (base64) => {
    const base64Response = await fetch(base64);
    return await base64Response.blob();
}

const ProductFormModal = (props) => {
    const {response, makeRequest} = useFetch();
    const {showNotification} = useNotification();
    const [categories, setCategories] = useState([]);
    const [allergens, setAllergens] = useState([]);
    const inNewsRef = useRef();
    const imageRef = useRef();
    const translateNameRef = useRef();
    const [showNewsInfo, setShowNewsInfo] = useState(props.product && props.product.in_news == '1' || false)
    const [imageSrc, setImageSrc] =
        useState(CONFIG.appHost + ((props.product && props.product.image) ?
                props.product.image :
                '/image_placeholder.png'));

    useEffect(() => {
        makeRequest(CONFIG.adminApiUrl + 'category_ajax.php', 'post', {
            getAllCategories: 1
        });
        setTimeout(() => {
            makeRequest(CONFIG.apiUrl + 'menu_ajax.php', 'post', {
                getAllergens: 1
            });
        }, 100)

    }, []);

    useEffect(() => {
        if (response && response.requestData){
            if ('getAllCategories' in response.requestData){
                const cats = response.data.map(c => {
                    return {
                        id: c.id,
                        label: c.name,
                        selected: (props.product && props.product.categories) ? props.product.categories.includes(c.id) : false
                    }
                })

                setCategories([...cats]);
            } else if ('getAllergens' in response.requestData){
                const algns = response.data.map(a => {
                    return {
                        id: a.id,
                        label: a.name,
                        icon: a.label,
                        selected: (props.product && props.product.allergens) ? props.product.allergens.includes(a.uid) : false
                    }
                })

                setAllergens([...algns]);
            } else if ('editProduct' in response.requestData || 'createNewProduct' in response.requestData) {
                const notification = {
                    open: true,
                    type: 'error',
                    message: ('editProduct' in response.requestData) ? 'Errore durante la modifica del prodotto' : 'Errore durante la creazione del prodotto'
                }

                if (response.state === 'success') {
                    notification.type = 'success';
                    notification.message = ('editProduct' in response.requestData) ? 'Prodotto modificato con successo' : 'Prodotto creato con successo'
                }

                showNotification(notification);

                if (response.state === 'success') {
                    const event = new CustomEvent('productsChanged',
                        {
                            bubbles: true,
                            cancelable: true
                        });
                    window.dispatchEvent(event);

                    props.onClose()
                }
            }
        }
    }, [response]);

    const onInNewsChange = () => {
        setShowNewsInfo(inNewsRef.current.checked);
    }

    const onImageChange = async () => {
        const result = await getBase64(imageRef.current.files[0]);
        if (result.state === 'ok') {
            const url = await base64ToObjectURL(result.base64);
            setImageSrc(url);
        }
    }

    return <>
        <DialogModal
            onClose={props.onClose}
            open
            fullWidth
            PaperProps={{
                component: 'form',
                onSubmit: (event) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const formJson = Object.fromEntries(formData.entries());
                    const selectedCategories = categories.filter(c => c.selected).map(c => c.id);
                    const selectedAllergens = allergens.filter(a => a.selected).map(a => a.id);

                    const requestData = {
                        product: {
                            name: formJson.name,
                            description: formJson.description,
                            price: formJson.price,
                            in_news: inNewsRef.current.checked,
                            news_description: inNewsRef.current.checked ? formJson.newsDescription : '',
                            translate_name: translateNameRef.current.checked
                        },

                        categories: selectedCategories,
                        allergens: selectedAllergens
                    };

                    if (!props.editMode) {
                        requestData.createNewProduct = 1;
                    } else {
                        requestData.product.position_index = props.product.position_index;
                        requestData.editProduct = 1;
                        requestData.product.id = props.product.id;
                    }

                    let files = null;
                    if (inNewsRef.current.checked) {
                        if (imageRef.current.files[0])
                            files = {image: imageRef.current.files[0]};
                    }

                    makeRequest(CONFIG.adminApiUrl + 'product_ajax.php', 'post', requestData, files);
                },
            }}
            title={!props.editMode ? 'Crea prodotto' : 'Modifica prodotto'}
            actions={[
                {
                    variant: 'outlined',
                    color: 'brGrey',
                    onClick: props.onClose,
                    label: 'Annulla'
                },
                {
                    variant: 'contained',
                    type: 'submit',
                    label: !props.editMode ? 'Crea' : 'Salva'
                }
            ]}
        >
            <Grid container spacing={2} alignItems='center'>
                <Grid item xs={10}>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="name"
                        name="name"
                        label="Nome"
                        type="text"
                        defaultValue={(props.product && props.product.name) ? props.product.name : ''}
                        variant="standard"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        margin="dense"
                        id="price"
                        name="price"
                        label="Prezzo"
                        type="number"
                        inputProps={{
                            step: 0.01,
                            min: 0
                        }}
                        defaultValue={(props.product && props.product.price) ? props.product.price : 0}
                        variant="standard"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id="translateName"
                                name='translateName'
                                inputRef={translateNameRef}
                                defaultChecked={(props.product && props.product.translate_name == '1') ? true : false}
                            />
                        }
                        label="Traduci nome" />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        margin="dense"
                        id="description"
                        name="description"
                        label="Descrizione (opzionale)"
                        type="text"
                        defaultValue={(props.product && props.product.description) ? props.product.description : ''}
                        fullWidth
                        variant="standard"
                        multiline
                        rows={3}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id="inNews"
                                name='inNews'
                                onChange={onInNewsChange}
                                inputRef={inNewsRef}
                                defaultChecked={(props.product && props.product.in_news == '1') ? true : false}
                            />
                        }
                        label="Novità" />
                </Grid>
                { showNewsInfo && <>
                    <Grid item xs={12}>
                        <TextField
                            margin="dense"
                            id="newsDescription"
                            name="newsDescription"
                            label="Testo novità (opzionale)"
                            type="text"
                            defaultValue={(props.product && props.product.newsDescription) ? props.product.newsDescription : ''}
                            fullWidth
                            variant="standard"
                            multiline
                            rows={3}
                        />
                    </Grid>
                    <Grid item>
                        <div style={{
                            height: 350,
                            width: 350,
                            backgroundImage: `url(${imageSrc})`,
                            backgroundPosition: 'center',
                            backgroundSize: 'cover'
                        }}></div>
                    </Grid>
                    <Grid item>
                        <Button
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            startIcon={<FileUploadIcon />}
                        >
                            Upload file
                            <VisuallyHiddenInput ref={imageRef} onChange={onImageChange} type="file" />
                        </Button>
                    </Grid>
                </>}
                <Grid item xs={12}>
                    <ChipsSelector
                        chips={categories}
                        title='Categoria'
                        subheader='Seleziona una o più categorie'
                    />
                </Grid>
                <Grid item xs={12}>
                    <ChipsSelector
                        chips={allergens}
                        title='Allergeni'
                        subheader='Seleziona una o più allergeni'
                    />
                </Grid>
            </Grid>
        </DialogModal>
    </>;
}

export default ProductFormModal;